<div
  class="widget-wrapper flex flex-column h-full w-full border-round-xl align-items-stretch surface-card"
  [class]="getCssClass()"
  [ngClass]="{
    'surface-card': !activeWidget?.widget?.text?.backgroundColor,
    'gs-readonly': readonly,
  }"
  [style]="{
    backgroundColor:
      activeWidget?.widget?.text?.backgroundColor || 'transparent',
  }"
  [style.--border-color]="
    activeWidget?.widget?.text?.backgroundColor || '#000000'
  ">
  <div
    #widgetContainer
    class="widget-inner flex flex-column flex-1 w-full align-items-stretch overflow-hidden"
    [ngClass]="{ 'widget-fullscreen': activeWidget?.fullscreen }">
    @if (activeWidgetComponent && activeWidgetComponent.component) {
      @if (activeWidget?.fullscreen) {
        <button
          class="nct fixed right-0 top-0 m-2"
          style="z-index: 9999"
          [rounded]="true"
          pButton
          (click)="endFullscreen()"
          icon="fas fa-xmark"></button>
      }
      @if (activeWidget && activeWidget.widget?.headline && !export) {
        <h3
          class="nct text-left m-0 flex gap-2 top-0 left-0 right-0 text-sm font-bold text-color-secondary px-2 py-2 align-items-center border-round-top-xl">
          {{ activeWidget.widget?.headline }}
        </h3>
      }

      @if (export && activeWidget && activeWidget.widget?.headline) {
        <app-header [text]="activeWidget.widget.headline" />
      }

      <ng-container
        *ngComponentOutlet="
          activeWidgetComponent.component;
          inputs: activeWidgetComponent.inputs
        ">
      </ng-container>
    } @else {
      <p-speedDial
        class="h-full w-full justify-content-around align-items-center"
        showIcon="fas fa-plus"
        [model]="items"
        [radius]="120"
        type="circle">
        <ng-template pTemplate="item" let-item>
          <p-button
            (click)="setWidgetType(item.type)"
            size="small"
            [icon]="item.icon"
            [pTooltip]="item.tooltip"
            tooltipPosition="top"
            [tooltipOptions]="{
              positionTop: -22,
              showDelay: 500,
            }"
            severity="secondary"
            [rounded]="true"></p-button>
        </ng-template>
      </p-speedDial>
    }

    <footer
      [hidden]="!!activeWidget && readonly && isContentWidget()"
      [ngClass]="{
        'opacity-0': export,
        'cursor-move': !readonly,
        'pointer-events-none': readonly,
      }"
      class="gs-handler nct flex gap-2 justify-content-end text-sm font-bold text-color-secondary px-2 py-1 align-items-center border-round-bottom-md transition-all transform shadow-3 hover:shadow-8 transition-duration-300 overflow-hidden">
      @if (!readonly) {
        <button
          pButton
          severity="secondary"
          [rounded]="true"
          class="flex-shrink-1 sm:flex gs-handler p-button-xs pointer-events-none"
          icon="fas fa-up-down-left-right"
          [text]="true"></button>
      }
      @if (activeWidget && activeWidget.widget) {
        @if (activeWidget.widget.indicators.length > 0) {
          <button
            (click)="showInfo(activeWidget._id)"
            pTooltip="Indikatoren-Informationen"
            pButton
            severity="secondary"
            [rounded]="true"
            class="flex flex-shrink-1 p-button-xs pointer-events-auto"
            icon="fas fa-info-circle"
            [text]="true"></button>
        }

        @if (
          !disableControls &&
          widgetHelper.isDataWidget(activeWidget.type) &&
          activeWidget.widget.dataLayer &&
          activeWidget.widget.context !== 'external'
        ) {
          <div
            class="flex flex-shrink-0"
            [style]="{ 'max-width': readonly ? '90%' : '64%' }">
            @switch (activeWidget?.widget?.focusProperty) {
              @case ('dataLayer') {
                <app-fast-switch-data-layer
                  [readonly]="readonly && disableControls"
                  class="pointer-events-auto"
                  (changeLayer)="onLayerChanged($event)"
                  (changeGroup)="setWidgetGeoGroup($event)"
                  [indicatorIds]="widgetIndicatorIds"
                  [activeGroup]="activeWidget.widget.activeGroup"
                  [dataLayerId]="
                    activeWidget.widget.dataLayer
                  "></app-fast-switch-data-layer>
              }
              @case ('indicator') {
                <app-fast-switch-indicator
                  [readonly]="readonly && disableControls"
                  class="pointer-events-auto"
                  (changeIndicator)="
                    onIndicatorChanged($event.indicator, $event.typeId)
                  "
                  (changeGroup)="setWidgetGeoGroup($event)"
                  [typeId]="activeWidget.widget.dataLayerType"
                  [indicatorIds]="widgetIndicatorIds"
                  [activeGroup]="activeWidget.widget.activeGroup"
                  [indicatorId]="
                    activeWidget.widget.indicator
                  "></app-fast-switch-indicator>
              }
              @case ('feature') {
                <app-fast-switch-feature
                  [readonly]="readonly && disableControls"
                  class="pointer-events-auto"
                  [dataLayerId]="activeWidget.widget.dataLayer"
                  [featureKey]="activeWidget.widget.feature"
                  (changeFeature)="
                    onFeatureChanged($event.feature, $event.layer)
                  "
                  [indicatorIds]="widgetIndicatorIds"></app-fast-switch-feature>
              }
            }
          </div>
        } @else if (
          !disableControls && activeWidget.widget.context === 'external'
        ) {
          <app-wegweiser-fast-switch
            class="pointer-events-auto"
            (selectionChange)="updateChartData()"
            [readonly]="readonly && disableControls"
            [widget]="activeWidget"></app-wegweiser-fast-switch>
        }

        @if (disableControls) {
          {{ widgetCaption }}
        }
        <div class="flex-shrink-1 sm:flex gap-2 ml-auto">
          @if (!disableControls && !readonly) {
            <button
              pButton
              (click)="remove()"
              severity="secondary"
              [rounded]="true"
              class="p-button-xs"
              icon="fas fa-trash"
              [text]="true"></button>
          }

          @if (
            !disableControls &&
            !readonly &&
            !widgetHelper.isPlaceholderWidget(activeWidget.type)
          ) {
            <button
              pButton
              (click)="config()"
              severity="secondary"
              [rounded]="true"
              class="p-button-xs"
              icon="fas fa-cog"
              [text]="true"></button>
          }

          <button
            pButton
            severity="secondary"
            [rounded]="true"
            class="p-button-xs pointer-events-auto"
            icon="fas fa-ellipsis-v"
            (click)="menu.toggle($event)"
            [text]="true"></button>
        </div>
      }
    </footer>
    <p-menu appendTo="body" #menu [model]="widgetMenu" [popup]="true" />
  </div>
</div>
